import { __assign } from "tslib";
import { normalizeUrl } from './utils/normalize-url';
import { extendDeep } from './utils/extend-deep';
import { resize } from './resize';
import { MediaType, MediaManagerVersion } from './types';
var WixThumbnailSize;
(function (WixThumbnailSize) {
    WixThumbnailSize["Thumbnail"] = "thumbnail";
    WixThumbnailSize["Preview"] = "preview";
})(WixThumbnailSize || (WixThumbnailSize = {}));
var getUrlForResize = function (item, settings, mmgrVersion) {
    if (mmgrVersion === void 0) { mmgrVersion = MediaManagerVersion.G5; }
    var filesUrl = settings.filesUrl;
    if (item.thumbnailUrl) {
        return filesUrl + "/" + item.thumbnailUrl;
    }
    switch (item.mediaType) {
        case MediaType.Picture:
        case MediaType.SiteIcon:
        case MediaType.Watermark:
            return filesUrl + "/" + item.fileUrl;
        case MediaType.SecurePicture:
            return mmgrVersion === MediaManagerVersion.G6
                ? settings.apiUrl + "/site/media/files/secure/" + item.fileUrl
                : filesUrl + "/" + item.fileUrl;
        case MediaType.Video:
        case MediaType.VideoAlpha:
            return item.videoThumbnailUrl ? filesUrl + "/" + item.videoThumbnailUrl : null;
        case MediaType.SecureVideo:
            if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[2] && item.fileOutput.image[2].url) {
                return filesUrl + "/" + item.fileOutput.image[2].url;
            }
            break;
        case MediaType.UserFont:
            if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[0] && item.fileOutput.image[0].url) {
                return filesUrl + "/" + item.fileOutput.image[0].url;
            }
            break;
        default:
            break;
    }
};
var getSameUrls = function (thumbnailSizes, url) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
        var _a;
        return (__assign(__assign({}, urls), (_a = {}, _a[sizeName + "Url"] = url, _a)));
    }, {});
};
var getResizedUrls = function (thumbnailSizes, urlForResize, imageOperationsApi, previewUrlForResize) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
        var _a;
        var resizableUrl = sizeName === WixThumbnailSize.Thumbnail && previewUrlForResize ? previewUrlForResize : urlForResize;
        var url = resize(resizableUrl, thumbnailSizes[sizeName], imageOperationsApi);
        return __assign(__assign({}, urls), (url && (_a = {}, _a[sizeName + "Url"] = url, _a)));
    }, {});
};
var buildOriginalUrl = function (item, settings, mmgrVersion) {
    return normalizeUrl(item.mediaType === 'secure_picture' && mmgrVersion === MediaManagerVersion.G6
        ? settings.apiUrl + "/site/media/files/secure/" + item.fileUrl
        : settings.filesUrl + "/" + item.fileUrl);
};
export var getWixThumbnailsUrls = function (item, thumbnailSizes, settings, mmgrVersion) {
    if (mmgrVersion === void 0) { mmgrVersion = MediaManagerVersion.G5; }
    var urlForResize = getUrlForResize(item, settings, mmgrVersion);
    var previewUrlForResize = item.previewUrl ? settings.filesUrl + "/" + item.previewUrl : null;
    var urls = {};
    if (item.mediaType === MediaType.Shape || (item.fileUrl && item.fileUrl.split('.').pop() === 'gif')) {
        urls = getSameUrls(thumbnailSizes, buildOriginalUrl(item, settings, mmgrVersion));
    }
    else if (urlForResize) {
        var isAlphaVideo = (item.tags || []).indexOf('_mp4_alpha') !== -1;
        if (isAlphaVideo) {
            thumbnailSizes = extendDeep({}, thumbnailSizes, { thumbnail: { mode: 'fit' } });
        }
        urls = getResizedUrls(thumbnailSizes, urlForResize, settings.imageOperationsApi, previewUrlForResize);
    }
    if (item.fileUrl) {
        urls.originalUrl = buildOriginalUrl(item, settings, mmgrVersion);
    }
    return urls;
};
//# sourceMappingURL=get-wix-thumbnails-urls.js.map